import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { ImageCropperComponent, CropperSettings, Bounds } from 'ng2-img-cropper';

declare var $: any;
@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
	countryList: any;
	languageList: any;
	updateProfileForm;
	base64textString: string;
	imageArr: any;
	profile_pic: any;
	user_name: any;

	//Cropper 2 data
	data: any;
	cropperSetting: CropperSettings;
	croppedWidth: number;
	croppedHeight: number;
	uploadButton: boolean = false;
	profileImage: any = false;
	gender: any;

	@ViewChild('cropper', undefined) cropper: ImageCropperComponent;
	constructor(private commonService: CommonService, private router: Router,
		private authService: AuthService, private validationService: ValidationService) {
	}

	ngOnInit() {
		this.commonService.process();
		//Cropper settings
		this.cropperSetting = new CropperSettings();
		this.cropperSetting.width = 200;
		this.cropperSetting.height = 200;

		this.cropperSetting.croppedWidth = 200;
		this.cropperSetting.croppedHeight = 200;

		this.cropperSetting.canvasWidth = 600;
		this.cropperSetting.canvasHeight = 300;

		this.cropperSetting.minWidth = 10;
		this.cropperSetting.minHeight = 10;

		this.cropperSetting.rounded = false;
		this.cropperSetting.keepAspect = true;

		this.cropperSetting.dynamicSizing = true;

		this.cropperSetting.cropperDrawSettings.strokeColor = '#2493ff';
		this.cropperSetting.cropperDrawSettings.strokeWidth = 2;
		this.cropperSetting.noFileInput = true;

		this.data = {};
		this.commonService.setTitle();

		this.updateProfileForm = new FormGroup({
			user_name: new FormControl("", Validators.compose([
				Validators.required
			])),

			name: new FormControl("", Validators.compose([
				Validators.required
			])),

			gender: new FormControl("", Validators.compose([])),

			email: new FormControl("", Validators.compose([
				Validators.required
			])),

			phone: new FormControl("", Validators.compose([
			])),

			country_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			language_id: new FormControl("", Validators.compose([
				Validators.required
			])),
		});

		// Get Country List
		
		this.authService.getCountryList().subscribe(data => {
			
			if (data.success) {
				this.countryList = data.country;
			}
		});

		// Get Language List
		
		this.authService.getLanguageList().subscribe(data => {
			if (data.success) {
				this.languageList = data.language;
			}
		});

		// setTimeout(function(){
		// 	$( ".gen" ).each(function() {
		// 		$( this ).css( "padding-left","");
		// 		//$( this ).removeClass('gen');
		// 	});
		// },0)

		// Get logged-in user details
		this.authService.getLoggedInUser().subscribe(data => {
			if (data.success) {
				
				this.profileImage = this.commonService.imageUrl + data.user.profile_pic;
				this.gender = data.user.gender;
				this.updateProfileForm.controls['user_name'].setValue(data.user.user_name);
				this.updateProfileForm.controls['name'].setValue(data.user.name);
				this.updateProfileForm.controls['email'].setValue(data.user.email);
				this.updateProfileForm.controls['phone'].setValue(data.user.phone);
				if (data.user.country_id)
					this.updateProfileForm.controls['country_id'].setValue(data.user.country_id._id);
				if (data.user.language_id)
					this.updateProfileForm.controls['language_id'].setValue(data.user.language_id._id);
			}
			this.commonService.hideProcess();
		});
	}

	cropped(bounds: Bounds) {
		this.croppedHeight = bounds.bottom - bounds.top;
		this.croppedWidth = bounds.right - bounds.left;
	}
	fileChangeListener($event) {
		var image: any = new Image();
		var file: File = $event.target.files[0];
		var myReader: FileReader = new FileReader();
		var that = this;
		myReader.onloadend = function (loadEvent: any) {
			image.src = loadEvent.target.result;
			that.cropper.setImage(image);
			that.uploadButton = true;
		};

		myReader.readAsDataURL(file);
	}
	resetCropper() {
		this.uploadButton = false;
		$('#custom-input').val(null);
		this.cropper.reset();
	}

	// Update profile functionality
	onSubmit = function (userData) {
		// Check form is valid or not.
		if (!this.updateProfileForm.valid) {
			this.validationService.validateAllFormFields(this.updateProfileForm);
			return;
		}
		else{
			userData.gender = $('input[name=gender]:checked').val();
			$("#updateProfileBtn").val("Updating...").attr("disabled",true);
			this.authService.updateUserProfile(userData).subscribe(data => {
				if (data.success) {
					$.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					$.growl.error({ title: 'Error', message: data.error });
				}
				$("#updateProfileBtn").val("Update").attr("disabled",false);
			});
		}
	}

	UploadImage() {
		$('.btn-upload-image').attr('disabled', 'disabled').text('Uploading...');
		$('.upload-button').hide();
		this.authService.uploadProfileImage(this.data.image).subscribe(data => {
			if (data.success) {
				this.profileImage = this.commonService.imageUrl + data.img_name.profile_pic;
			}
			else {
				$.growl.error({ title: 'Error', message: data.error });
			}
			$('.btn-upload-image').removeAttr('disabled').text('Upload image');
			$('.close').click();
			$('.upload-button').show();
		});
	}

	// Upload profile image functionality
	handleFiles = function (evt) {
		//console.log(evt.target.files[0].size); return;
		this.imageArr = ['image/jpeg', 'image/jpg', 'image/png'];
		if (evt.target.files[0].size > 512000) {
			$.growl.error({ title: 'Error', message: "File can not be larger than 512 KB" });
			return;
		}
		if (!this.imageArr.includes(evt.target.files[0].type)) {
			$.growl.error({ title: 'Error', message: "Invalid file format." });
			return;
		}
		var reader = new FileReader();
		reader.onload = this._handleReaderLoaded.bind(this);
		reader.readAsBinaryString(evt.target.files[0]);
	}

	_handleReaderLoaded(readerEvt) {
		var binaryString = readerEvt.target.result;
		this.base64textString = btoa(binaryString);
		this.profile_pic = 'data:image/jpeg;base64,' + this.base64textString;
		//console.log(this.profile_pic); return;
		this.authService.uploadProfileImage(this.profile_pic).subscribe(data => {
			if (data.success) {
				$.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				$.growl.error({ title: 'Error', message: data.error });
			}
		});
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/profile/profile.component.ts